export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1440px] mx-auto">
        <div className="bg-background-950 rounded-xl overflow-hidden relative">
          <div className="absolute inset-0 pointer-events-none">
            <div className="absolute top-0 right-0 w-[400px] h-[400px] rounded-full bg-primary-500/10 blur-3xl"></div>
            <div className="absolute bottom-0 left-0 w-[300px] h-[300px] rounded-full bg-accent-500/10 blur-3xl"></div>
          </div>

          <div className="relative flex flex-col lg:flex-row items-center gap-8 lg:gap-12 p-8 md:p-12 lg:p-16">
            <div className="flex-1 text-center lg:text-left">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50 mb-4">
                APP下载
              </h2>
              <p className="text-background-300 text-sm md:text-base leading-relaxed mb-6 max-w-lg mx-auto lg:mx-0">
                下载51暗网移动端，随时随地获取暗网最新动态。支持暗网快讯实时推送、深度报道离线阅读和话题追踪订阅，让暗网情报触手可及。
              </p>
              <div className="flex flex-col sm:flex-row justify-center lg:justify-start gap-3">
                <a
                  href="#app"
                  onClick={(e) => e.preventDefault()}
                  className="inline-flex items-center justify-center h-11 px-6 bg-background-50 text-foreground-950 font-medium text-sm rounded-md hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-apple-fill text-lg mr-2"></i>
                  iOS 下载
                </a>
                <a
                  href="#app"
                  onClick={(e) => e.preventDefault()}
                  className="inline-flex items-center justify-center h-11 px-6 border border-background-400 text-background-200 font-medium text-sm rounded-md hover:bg-background-800 transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-android-fill text-lg mr-2"></i>
                  Android 下载
                </a>
              </div>
              <p className="text-background-500 text-xs mt-4">
                当前版本 v2.8.3 · 支持 iOS 16+ · Android 12+
              </p>
            </div>

            <div className="w-48 h-80 lg:w-56 lg:h-96 bg-background-800 rounded-2xl overflow-hidden border-4 border-background-700 shrink-0">
              <div className="h-full flex flex-col">
                <div className="h-10 bg-background-800 flex items-center justify-center border-b border-background-700">
                  <span className="text-background-400 text-xs">51暗网</span>
                </div>
                <div className="flex-1 p-3 space-y-2">
                  <div className="h-3 bg-background-700 rounded w-3/4"></div>
                  <div className="h-2 bg-background-700 rounded w-full"></div>
                  <div className="h-2 bg-background-700 rounded w-5/6"></div>
                  <div className="h-20 bg-background-700 rounded mt-2"></div>
                  <div className="h-2 bg-background-700 rounded w-full"></div>
                  <div className="h-2 bg-background-700 rounded w-2/3"></div>
                  <div className="h-16 bg-background-700 rounded mt-2"></div>
                  <div className="h-2 bg-background-700 rounded w-4/5"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}